module.exports = __webpack_public_path__ + "img/Icon-Notes.621fb8e7.svg";